import React from 'react';
import '../styles/message.css'; // Import the CSS file

const Message = ({ messageType, messageText }) => {
  const messageClass = messageType ? `message ${messageType}` : '';
  return messageText ? (
    <p className={messageClass}>
      {messageText.split('\n').map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))}
    </p>
  ) : null;
};


export default Message;
